import { createSelector } from 'reselect';
import { getBoughtInStore } from './get-bought-in-store';

/**
 * Returns whether the offer filter should be in the enabled or disabled state.
 */
export const getBoughtInStoreOfferFilterEnabled = createSelector(
  [getBoughtInStore],
  (boughtInStore): boolean =>
    'offersFilter' in boughtInStore ? boughtInStore.offersFilter !== null : false,
);

/**
 * Returns whether the offer filter should be in the active (only offers) or
 * inactive (all products) state.
 */
export const getBoughtInStoreOfferFilterActiveState = createSelector(
  [getBoughtInStore],
  (boughtInStore): boolean =>
    'offersFilter' in boughtInStore ? !!boughtInStore.offersFilter : false,
);
